import { IoChevronUp } from 'react-icons/io5';
import { cn } from 'shared/lib';
import { IPersonaEmbedSettings } from 'entities/tavus/persona';
import { Call, Keyboard, Microphone2, Video } from 'iconsax-reactjs';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { LuMonitor, LuMonitorOff } from 'react-icons/lu';
import { TbKeyboard, TbKeyboardOff } from 'react-icons/tb';
import PoweredBy from './PoweredBy';

const ToolBarOnCall = ({
  windowFields
}: {
  windowFields: IPersonaEmbedSettings;
}) => {
  return (
    <div
      className={
        'ag-flex ag-flex-col ag-absolute ag-bottom-0 ag-gap-y-2 ag-right-0 ag-mx-auto ag-justify-center ag-items-center ag-left-0'
      }
    >
      <div className="ag-flex ag-mx-auto ag-justify-center  ag-items-center ag-gap-2">
        <div className="ag-h-10 ag-w-[1px] ag-bg-neutral-300"></div>
        <button
          type="button"
          className="ag-rounded-[10px] ag-bg-white-opacity-70 ag-p-2 ag-h-10 ag-w-10 ag-flex ag-flex-col ag-justify-center ag-text-dark-purple"
        >
          {windowFields.captions_by_default ? (
            <TbKeyboard size="24" color="currentColor" />
          ) : (
            <TbKeyboardOff size="24" color="#DC2626" />
          )}
        </button>
        {windowFields?.camera && (
          <button
            type="button"
            className="ag-rounded-[10px] ag-bg-white-opacity-70 ag-p-2 ag-h-10 ag-w-10 ag-flex ag-flex-col ag-justify-center ag-text-dark-purple"
          >
            <Video size="100%" color="currentColor" />
          </button>
        )}
        {windowFields?.screen_share && (
          <button
            type="button"
            className="ag-rounded-[10px] ag-bg-white-opacity-70 ag-p-2 ag-h-10 ag-w-10 ag-flex ag-flex-col ag-justify-center ag-text-dark-purple"
          >
            {windowFields?.screen_share ? (
              <LuMonitor size="24" color="currentColor" />
            ) : (
              <LuMonitorOff size="24" color="#DC2626" />
            )}
          </button>
        )}
        <div className="ag-flex ag-items-center ag-rounded-full ag-bg-neutral-200 ag-border ag-border-white ag-relative">
          <button
            type="button"
            className={cn(
              'ag-size-10 ag-p-2 ag-border ag-bg-white-opacity-70 ag-text-dark-purple ag-rounded-full ag-relative ag-left-0 ag-flex ag-items-center ag-justify-center'
            )}
          >
            <Microphone2 color="currentColor" />
          </button>
          <button
            type="button"
            className="ag-text-dark-purple ag-pl-1.5 ag-pr-3"
          >
            <IoChevronUp />
          </button>
        </div>
        <button
          type="button"
          className="ag-h-10 ag-w-10 ag-bg-button-red ag-text-white ag-py-2 ag-rounded-full ag-flex ag-flex-row ag-items-center"
        >
          <Call color="currentColor" size={'100%'} />
        </button>
      </div>
      <PoweredBy isPoweredBy={windowFields?.powered_by} />
    </div>
  );
};

export default ToolBarOnCall;
